import React from 'react';
import Container from 'react-bootstrap/Container';
import './index.scss';

export default function ImpermaxV3Banner() {
  return (<Container className="impermax-v3-banner">
    <a className="card" href="https://app.impermax.finance" target="_blank">
      <h4>🐐 <strong>ImpermaxV3 is live! 🐐 </strong></h4>
      <br />
       Borrow and lend on concentrated liquidity markets or any V2 market at <span style={{ textDecoration: "underline"}}>https://app.impermax.finance</span>
      <br />
       This site will remain functional for the following months as we slowly deprecate it.
    </a>
  </Container>);
}
